import React, { useState } from 'react';
import ReactDOM from "react-dom";
import { useLocation, useNavigate } from "react-router-dom";


import style from "./editRolePrivilege.module.css";
import { ErrorToast, SuccessToast } from '../../../components/toastMessage';
import axios from 'axios';
import { BASE_URL } from '../../../constants/Constants';
import { _axios } from '../../../utils/axios';
const editRolePrivilege = () => {
  const { state } = useLocation();
  const { user } = state
  const [checkedItems, setCheckedItems] = useState<boolean[]>([
    true, true, true, true, true, true,
    true, true, true, true, true, true,
    true, true, true, true, true, true,
  ]);
  // const [roleName, setRoleName] = useState<string>()
  const [formData, setFormData] = useState<any>({
    role_privilages_id: user.role_privilages_id,
    role_name: user.role_name,

    create_application: user.create_application,
    read_application: user.read_application,
    write_application: user.write_application,
    upload_application_document: user.upload_application_document,
    download_application_document: user.download_application_document,

    create_certificate: user.create_certificate,
    write_certificate: user.write_certificate,
    read_certificate: user.read_certificate,
    upload_certificate_document: user.upload_certificate_document,
    download_certificate_document: user.download_certificate_document,

    create_demand_note: user.create_demand_note,
    read_demand_note: user.read_demand_note,
    write_demand_note: user.write_demand_note,
    upload_demand_note_document: user.upload_demand_note_document,
    download_demand_note_document: user.download_demand_note_document,

    create_payment: user.create_payment,
    read_payment: user.read_payment,
    write_payment: user.write_payment,
    upload_payment_document: user.upload_payment_document,
    download_payment_document: user.download_payment_document,


    create_registration_application: user.create_registration_application,
    write_registration_application: user.write_registration_application,
    read_registration_application: user.read_registration_application,
    upload_registration_application_document: user.upload_registration_application_document,
    download_registration_application_document: user.download_registration_application_document,
  });
  const navigate = useNavigate();

  const handleInputChange = (e: { target: { name: string, value: string } }) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: formData?.[name] === 1 ? 0 : 1,
    });
  };

  const onPublish = () => {
    _axios.patch(`${BASE_URL}/api/role-privilages`,
      formData
    )
      .then(function (response) {
        if (response?.data?.success === 0) {
          ErrorToast(response?.data?.message)
          return
        }
        SuccessToast('User permissions Updated')
        navigate("/role-privilege")
        // handle success
        console.log(response);
      })
      .catch(function (error: any) {
        // handle error
        console.log(error);
      })
      .finally(function () {
        // always executed
      });
  }

  return (
    <div>
      <div className={style.bodyBox}>
        {/* Main content here */}
        <div className={style.bodyHeading}>
          <p className={style.bodyTitle}>Role Privileges </p>
        </div>
        <div className={`${style.subheadings} mt-10`}>
          <h6> Role Name</h6>
          <div className={style.inputContainerBody}>
            <input
              type="text"
              disabled
              value={formData.role_name}
              onChange={(e) => setFormData({ ...formData, role_name: e.target.value })}
              className={`${style.inputEditRole} pl-3`}
            />

          </div>
        </div>

        <div className={style.firstRow}>


          <div>
            <dl>
              <dt className={style.headinglist}>

                {checkedItems[0] && <> Application</>}
              </dt>
              <dd>
                <input
                  type="checkbox"
                  name='create_application'
                  checked={formData.create_application === 1}
                  // onChange={handleInputChange}
                  className={style.addInput}
                />
                {checkedItems[0] && <> - Create Application</>}
              </dd>
              <dd>
                <input
                  type="checkbox"
                  className={style.addInput}
                  name='read_application'
                  checked={formData.read_application === 1}
                // onChange={handleInputChange}
                />
                {checkedItems[1] && <> - Read Application</>}
              </dd>
              <dd>
                <input
                  type="checkbox"
                  className={style.addInput}
                  name='write_application'
                  checked={formData.write_application === 1}
                // onChange={handleInputChange}
                />
                {checkedItems[2] && <> - Write Application</>}
              </dd>
              <dd>
                <input
                  type="checkbox"
                  className={style.addInput}
                  name='upload_application_document'
                  checked={formData.upload_application_document === 1}
                // onChange={handleInputChange}
                />
                {checkedItems[3] && <> - Upload Document</>}
              </dd>
              <dd>
                <input
                  type="checkbox"
                  className={style.addInput}
                  name='download_application_document'
                  checked={formData.download_application_document === 1}
                // onChange={handleInputChange}
                />
                {checkedItems[4] && <> - Download Document</>}
              </dd>
            </dl>
          </div>

          {/* second list  */}


          <div>
            <dl className={style.contentLeft}>
              <dt className={style.headinglist}>

                {checkedItems[0] && <> Registration Application</>}
              </dt>
              <dd>
                <input
                  type="checkbox"
                  className={style.addInput}
                  name='create_registration_application'
                  checked={formData.create_registration_application === 1}
                // onChange={handleInputChange}
                />
                {checkedItems[0] && <> - Create Registration Application</>}
              </dd>
              <dd>
                <input
                  type="checkbox"
                  className={style.addInput}
                  name='read_registration_application'
                  checked={formData.read_registration_application === 1}
                // onChange={handleInputChange}
                />
                {checkedItems[1] && <> - Read Registration Application</>}
              </dd>
              <dd>
                <input
                  type="checkbox"
                  className={style.addInput}
                  name='write_registration_application'
                  checked={formData.write_registration_application === 1}
                // onChange={handleInputChange}
                />
                {checkedItems[2] && <> - Write Registration Application</>}
              </dd>
              <dd>
                <input
                  type="checkbox"
                  className={style.addInput}
                  name='upload_registration_application_document'
                  checked={formData.upload_registration_application_document === 1}
                // onChange={handleInputChange}
                />
                {checkedItems[3] && <> - Upload Document</>}
              </dd>
              <dd>
                <input
                  type="checkbox"
                  className={style.addInput}
                  name='download_registration_application_document'
                  checked={formData.download_registration_application_document === 1}
                // onChange={handleInputChange}
                />
                {checkedItems[4] && <> - Download Document</>}
              </dd>
            </dl>
          </div>

          {/* demand note */}


          <div>
            <dl>
              <dt className={style.headinglist}>

                {checkedItems[0] && <>  Demand Note</>}
              </dt>
              <dd>
                <input
                  type="checkbox"
                  className={style.addInput}
                  name='create_demand_note'
                  checked={formData.create_demand_note === 1}
                // onChange={handleInputChange}
                />
                {checkedItems[0] && <> - Create Demand Note</>}
              </dd>
              <dd>
                <input
                  type="checkbox"
                  className={style.addInput}
                  name='read_demand_note'
                  checked={formData.read_demand_note === 1}
                // onChange={handleInputChange}
                />
                {checkedItems[1] && <> - Read Demand Note</>}
              </dd>
              <dd>
                <input
                  type="checkbox"
                  className={style.addInput}
                  name='write_demand_note'
                  checked={formData.write_demand_note === 1}
                // onChange={handleInputChange}
                />
                {checkedItems[2] && <> - Write Demand Note</>}
              </dd>
              <dd>
                <input
                  type="checkbox"
                  className={style.addInput}
                  name='upload_demand_note_document'
                  checked={formData.upload_demand_note_document === 1}
                // onChange={handleInputChange}
                />
                {checkedItems[3] && <> - Upload Document</>}
              </dd>
              <dd>
                <input
                  type="checkbox"
                  className={style.addInput}
                  name='download_demand_note_document'
                  checked={formData.download_demand_note_document === 1}
                // onChange={handleInputChange}
                />
                {checkedItems[4] && <> - Download Document</>}
              </dd>
            </dl>
          </div>

        </div>

        {/* second column start */}
        <div className={style.firstRow}>

          {/* Payment  */}

          <div>
            <dl>
              <dt className={style.headinglist}>

                {checkedItems[0] && <> Payment</>}
              </dt>
              <dd>
                <input
                  type="checkbox"
                  className={style.addInput}
                  name='create_payment'
                  checked={formData.create_payment === 1}
                // onChange={handleInputChange}
                />
                {checkedItems[0] && <> - Create Payment</>}
              </dd>
              <dd>
                <input
                  type="checkbox"
                  className={style.addInput}
                  name='read_payment'
                  checked={formData.read_payment === 1}
                // onChange={handleInputChange}
                />
                {checkedItems[1] && <> - Read Payment</>}
              </dd>
              <dd>
                <input
                  type="checkbox"
                  className={style.addInput}
                  name='write_payment'
                  checked={formData.write_payment === 1}
                // onChange={handleInputChange}
                />
                {checkedItems[2] && <> - Write Payment</>}
              </dd>
              <dd>
                <input
                  type="checkbox"
                  className={style.addInput}
                  name='upload_payment_document'
                  checked={formData.upload_payment_document === 1}
                // onChange={handleInputChange}
                />
                {checkedItems[3] && <> - Upload Document</>}
              </dd>
              <dd>
                <input
                  type="checkbox"
                  className={style.addInput}
                  name='download_payment_document'
                  checked={formData.download_payment_document === 1}
                // onChange={handleInputChange}
                />
                {checkedItems[4] && <> - Download Document</>}
              </dd>
            </dl>
          </div>

          {/* certication */}
          <div>
            <dl>
              <dt className={style.headinglist}>

                {checkedItems[0] && <> Certificate</>}
              </dt>
              <dd>
                <input
                  type="checkbox"
                  className={style.addInput}
                  name='create_certificate'
                  checked={formData.create_certificate === 1}
                // onChange={handleInputChange}
                />
                {checkedItems[0] && <> - Create Certificate</>}
              </dd>
              <dd>
                <input
                  type="checkbox"
                  className={style.addInput}
                  name='read_certificate'
                  checked={formData.read_certificate === 1}
                // onChange={handleInputChange}
                />
                {checkedItems[1] && <> - Read Certificate</>}
              </dd>
              <dd>
                <input
                  type="checkbox"
                  className={style.addInput}
                  name='write_certificate'
                  checked={formData.write_certificate === 1}
                // onChange={handleInputChange}
                />
                {checkedItems[2] && <> - Write Certificate</>}
              </dd>
              <dd>
                <input
                  type="checkbox"
                  className={style.addInput}
                  name='upload_certificate_document'
                  checked={formData.upload_certificate_document === 1}
                // onChange={handleInputChange}
                />
                {checkedItems[3] && <> - Upload Document</>}
              </dd>
              <dd>
                <input
                  type="checkbox"
                  className={style.addInput}
                  name='download_certificate_document'
                  checked={formData.download_certificate_document === 1}
                />
                {checkedItems[4] && <> - Download Document</>}
              </dd>
            </dl>
          </div>
        </div>
        <div className={style.buttonSection}>
          <button
            // className={style.closeButton}
            className='closeButtonCss'
            onClick={() => navigate('/role-privilege')}>
            Close
          </button>
        </div>
      </div>
    </div>
  )
}

export default editRolePrivilege
